import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Navigation from './Navigation';
import useAuth from '../../hooks/useAuth';
import { FaGift } from 'react-icons/fa';
import AdminFormLayout from './AdminFormLayout';

function AddReward() {
  const [form, setForm] = useState({
    name: '',
    points_required: '',
    description: '',
    stock: '',
    outlet_id: ''
  });
  const [outlets, setOutlets] = useState([]);
  const { verifyAndRefreshToken } = useAuth();
  const navigate = useNavigate();

  // Load outlets
  useEffect(() => {
    const fetchOutlets = async () => {
      const token = localStorage.getItem('sessionToken');
      const isValid = await verifyAndRefreshToken(token);
      if (!isValid) return navigate('/loginadmin');

      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}outletlist`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ limit: 100, start: 0 })
        });
        const json = await res.json();
        if (Array.isArray(json.results)) {
          setOutlets(json.results);
          if (json.results.length > 0) {
            setForm(prev => ({ ...prev, outlet_id: json.results[0].id.toString() }));
          }
        }
      } catch (err) {
        Swal.fire('Error', 'Failed to load outlets', 'error');
      }
    };
    fetchOutlets();
  }, [verifyAndRefreshToken, navigate]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const token = localStorage.getItem('sessionToken');
    const isValid = await verifyAndRefreshToken(token);
    if (!isValid) return navigate('/loginadmin');

    const payload = {
      name: form.name,
      points_required: Number(form.points_required),
      description: form.description,
      stock: Number(form.stock),
      outlet_id: Number(form.outlet_id),
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}admin/addreward`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      if (json.error === 0) {
        Swal.fire('Success', 'Reward added successfully!', 'success');
        navigate('/rewards');
      } else {
        Swal.fire('Error', json.message || 'Failed to add reward', 'error');
      }
    } catch (err) {
      Swal.fire('Error', 'Failed to add reward', 'error');
    }
  };

  return (
    <div>
      <Navigation />
      <AdminFormLayout
        icon={FaGift}
        eyebrow="Reward catalog"
        title="Create Reward"
        description="Tambahkan reward baru untuk katalog penukaran poin dengan informasi yang lengkap dan terdokumentasi."
        breadcrumbs={[
          { label: 'Dashboard', to: '/dashboardadmin' },
          { label: 'Reward Administration', to: '/rewards' },
          { label: 'Create Reward' },
        ]}
        tipsTitle="Reward Notes"
        tips={[
          'Gunakan nama reward yang jelas dan mudah dikenali.',
          'Pastikan jumlah poin dan stok sesuai dengan ketentuan program.',
          'Pilih outlet yang tepat agar reward tersedia pada lokasi yang sesuai.',
        ]}
      >
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text" name="name" value={form.name}
                  onChange={handleChange} required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Points Required</Form.Label>
                <Form.Control
                  type="number" name="points_required" value={form.points_required}
                  onChange={handleChange} required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea" name="description" rows={3}
                  value={form.description} onChange={handleChange} required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Stock</Form.Label>
                <Form.Control
                  type="number" name="stock" value={form.stock}
                  onChange={handleChange} required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Outlet</Form.Label>
                <Form.Select
                  name="outlet_id" value={form.outlet_id}
                  onChange={handleChange} required
                >
                  {outlets.map(o => (
                    <option key={o.id} value={o.id}>
                      {o.outlet_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className="form-actions">
            <Button variant="primary" type="submit">
              Save Reward
            </Button>
            <Button variant="secondary" onClick={() => navigate('/rewards')}>
              Cancel
            </Button>
          </div>
        </Form>
      </AdminFormLayout>
    </div>
  );
}

export default AddReward;
